import {Box, FormControl, MenuItem, Select, TextField} from "@mui/material";
import {useCallback, useEffect, useState} from "react";
import { useRefresh } from "react-admin";
import { moduleType } from "../../enums/common";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import { OneMealService } from "../../services/OneMealService";
import { TrialsService } from "../../services/TrialServices";
import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";
import reasonSubreasonService from "../../services/ReasonSubreasonServices";
import ChefForPartyService from "../../services/ChefForPartyService";

const trialService = new TrialsService();
const omsService = new OneMealService();
const chefForPartyService = new ChefForPartyService();
const reasonSubreasonServiceInstance = new reasonSubreasonService();
const inputSelectSx = {
  backgroundColor: "#fff",
  fontSize: "14px",
  "& .MuiSelect-select": {
    minHeight: "unset !important",
    padding: "10px 12px !important",
    display: "flex",
    alignItems: "center",
    lineHeight: 1.4,
  },
};

const inputTextSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    alignItems: "flex-start",
    "& fieldset": {
      borderColor: "rgba(0, 0, 0, 0.23)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(0, 0, 0, 0.4)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
      borderWidth: "1px",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    lineHeight: 1.4,
    "&::placeholder": {
      color: "rgba(0, 0, 0, 0.6)",
      opacity: 1,
    },
  },
  "& .MuiOutlinedInput-inputMultiline": {
    padding: "12px !important",
  },
};

interface ReasonCategory {
  category: string;
  subCategory: {
    label: string;
    markPenalty?: number;
    markleave?: boolean;
    markLeave?: boolean;
  }[];
}

interface InputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  data: any;
  requestFrom: moduleType;
}

const CookDenyDialog = ({ open, setOpen, data, requestFrom }: InputProps) => {
  const refresh = useRefresh();

  const [selectedReason, setSelectedReason] = useState<string>('');
  const [selectedSubReason, setSelectedSubReason] = useState<string>('');
  const [text, setText] = useState<string>('');
  const [reasonCategories, setReasonCategories] = useState<ReasonCategory[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  console.log(data);
  

  const loadData = useCallback(async () => {
    const response = requestFrom !== moduleType.CHEF_FOR_PARTY ? await reasonSubreasonServiceInstance.fetchReasonAndSubReason(
      ReasonSubreasonModuleEnum.ONE_MEAL_SERVICE,
      ActionTypeEnum.CHEFIT_DENIED
    ) : 
    await reasonSubreasonServiceInstance.fetchReasonAndSubReason(
      ReasonSubreasonModuleEnum.CHEF_FOR_PARTY,
      ActionTypeEnum.PARTY_DENIED
    )
    ;
    const rows =
      response?.data?.data?.data ||
      response?.data?.data ||
      response?.data ||
      [];
    const groupedReasons: Record<string, ReasonCategory> = {};

    rows.forEach((item: any) => {
      if (!item?.reason) return;

      if (!groupedReasons[item.reason]) {
        groupedReasons[item.reason] = {
          category: item.reason,
          subCategory: [],
        };
      }

      if (!item?.subReason) return;

      groupedReasons[item.reason].subCategory.push({
        label: item.subReason,
        markPenalty: Number(item?.markPenalty || 0),
        markleave: item?.markleave,
        markLeave: item?.markLeave,
      });
    });

    setReasonCategories([...Object.values(groupedReasons), { category: "Others", subCategory: [] }]);
  }, [requestFrom]);

  useEffect(()=>{
    loadData();
  },[loadData])

  const selectedReasonGroup = reasonCategories.find((item) => item.category === selectedReason);
  const subReasons = selectedReasonGroup?.subCategory || [];
  const isOthersSelected = selectedReason === "Others";
  const denialReason = isOthersSelected ? `Others - ${text.trim()}` : selectedSubReason;
  const isPrimaryDisabled = !selectedReason || (isOthersSelected ? text.trim() === "" : !selectedSubReason);
  const selectedSubReasonConfig = subReasons.find((item) => item.label === selectedSubReason);
  const formatSubReasonMeta = (
    subReason: { label: string; markPenalty?: number; markleave?: boolean; markLeave?: boolean }
    ) => {
      const markLeaveValue = subReason.markleave ?? subReason.markLeave ?? false;
      const markPenaltyValue = subReason.markPenalty ?? 0;

      const leaveText = markLeaveValue ? "Leave" : "No Leave";
      const penaltyText = markPenaltyValue ? "Penalty" : "No Penalty";

      return `${subReason.label} (${leaveText} | ${penaltyText})`;
    };

  const handleDeny = () => {
    if(!selectedReason) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Select a reason to continue",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }
    if(isOthersSelected) {
      if(text.trim() === ''){
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Enter a reason to continue",
          type: CustomSnackbarTypes.ERROR,
        });
        return;
      }
    } else if (!selectedSubReason) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Select a subreason to continue",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }
    setIsSubmitting(true);
    if (requestFrom === moduleType.TRIALS) {
      trialService
        .denyCook(data.id, {reason: denialReason})
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        })
        .catch(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Failed",
            type: CustomSnackbarTypes.ERROR,
          });
        })
        .finally(() => {
          setIsSubmitting(false);
          setOpen(false);
          refresh();
        });
    } else if(requestFrom === moduleType.CHEF_FOR_PARTY){
      chefForPartyService
        .denyParty(data?.chefForPartyId, data?.cookId, {reason: denialReason})
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        })
        .catch(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Failed",
            type: CustomSnackbarTypes.ERROR,
          });
        })
        .finally(() => {
          setIsSubmitting(false);
          setOpen(false);
          refresh();
          window.location.reload();
        });
    }
    else {
      omsService
        .denyCook(data.id, {reason: denialReason})
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        })
        .catch(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cook Denied Failed",
            type: CustomSnackbarTypes.ERROR,
          });
        })
        .finally(() => {
          setIsSubmitting(false);
          setOpen(false);
          refresh();
        });
    }
  };
  return (
    <CkMuiDialog
      isDialogOpen={open}
      setDialogOpen={setOpen}
      onDialogClose={() => {}}
      title={"Cook Deny"}
      primaryLabel={"Yes"}
      primaryAction={handleDeny}
      primaryDisabled={isPrimaryDisabled}
      secondaryLabel={"No"}
      secondaryAction={() => {
        setOpen(false);
      }}
      isLoading={isSubmitting}
    >
      <Box>
        <p>The cook you are denying for will be penalised, if it is not cooks fault kindly use change cook button to change cook on the visit</p>

        <FormControl fullWidth>
          <Select
              size="small"
              fullWidth
              id="reason"
              value={selectedReason}
              variant="outlined"
              displayEmpty
              renderValue={(value) =>
                value ? value : <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>Select Reason</span>
              }
              sx={inputSelectSx}
              onChange={(event: any) => {
                  setSelectedReason(event.target.value);
                  setSelectedSubReason("");
                  setText("");
              }}
          >
              {reasonCategories?.map((d: ReasonCategory) => (
                  <MenuItem key={d.category} value={d.category}>
                      {d.category}
                  </MenuItem>
              ))}
          </Select>
        </FormControl>

        {selectedReason && selectedReason !== "Others" && (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <Select
              size="small"
              id="sub-reason"
              variant="outlined"
              value={selectedSubReason}
              displayEmpty
              renderValue={(value) =>
                value && selectedSubReasonConfig
                  ? formatSubReasonMeta(selectedSubReasonConfig)
                  : <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>Select Subreason</span>
              }
              sx={inputSelectSx}
              onChange={(event: any) => {
                setSelectedSubReason(event.target.value);
              }}
            >
              {subReasons.map((subReason) => (
                <MenuItem key={subReason.label} value={subReason.label}>
                  {formatSubReasonMeta(subReason)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {selectedReason === 'Others' && (
            <TextField
                value={text}
                size="small"
                fullWidth
                multiline
                minRows={2}
                sx={{ mt: 2, ...inputTextSx }}
                variant="outlined"
                placeholder={"Enter the reason"}
                onChange={(event) => {
                  setText(event.target.value);
                }}
            />
        )}
      </Box>
    </CkMuiDialog>
  );
};

export default CookDenyDialog;
